<template>
  <div class="lb-table" :style="{ 'margin-top': marginTop}">
    <el-table ref="elTable" v-bind="$attrs" v-on="$listeners" :data="data" :header-cell-style="{ background: '#F5F5F5', color: '#2F3030', fontSize: '14px', fontWeight: '400' }"
      :span-method="this.merge ? this.mergeMethod : this.spanMethod">
      <lb-column v-bind="$attrs" v-for="( item, index ) in column " :key="index" :column="item">
      </lb-column>
    </el-table>
    <el-pagination class="lb-table-pagination" v-if="pagination" v-bind="$attrs" v-on="$listeners" @current-change="paginationCurrentChange"
      :style="{ 'margin-top': paginationTop, 'text-align': paginationAlign }">
    </el-pagination>
  </div>
</template>

<script>
import LbColumn from './lb-column'
export default {
  props: {
    column: Array,
    data: Array,
    spanMethod: Function,
    pagination: {
      type: Boolean,
      default: false
    },
    marginTop: {
      type: String,
      default: ''
    },
    paginationTop: {
      type: String,
      default: '15px'
    },
    paginationAlign: {
      type: String,
      default: 'right'
    },
    merge: Array
  },
  components: {
    LbColumn
  },
  data() {
    return {
      mergeLine: {},
      mergeIndex: {}
    }
  },
  created() {
    this.getMergeArr(this.data, this.merge)
  },
  computed: {
    dataLength() {
      return this.data.length
    }
  },
  methods: {
    clearSelection() {
      this.$refs.elTable.clearSelection()
    },
    toggleRowSelection(row, selected) {
      this.$refs.elTable.toggleRowSelection(row, selected)
    },
    toggleAllSelection() {
      this.$refs.elTable.toggleAllSelection()
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.elTable.toggleRowExpansion(row, expanded)
    },
    setCurrentRow(row) {
      this.$refs.elTable.setCurrentRow(row)
    },
    clearSort() {
      this.$refs.elTable.clearSort()
    },
    clearFilter(columnKey) {
      this.$refs.elTable.clearFilter(columnKey)
    },
    doLayout() {
      this.$refs.elTable.doLayout()
    },
    sort(prop, order) {
      this.$refs.elTable.sort(prop, order)
    },
    paginationCurrentChange(val) {
      this.$emit('p-current-change', val)
    },
    getMergeArr(tableData, merge) {
      if (!merge) return
      this.mergeLine = {}
      this.mergeIndex = {}
      merge.forEach((item, k) => {
        tableData.forEach((data, i) => {
          if (i === 0) {
            this.mergeIndex[item] = this.mergeIndex[item] || []
            this.mergeIndex[item].push(1)
            this.mergeLine[item] = 0
          } else {
            if (data[item] === tableData[i - 1][item]) {
              this.mergeIndex[item][this.mergeLine[item]] += 1
              this.mergeIndex[item].push(0)
            } else {
              this.mergeIndex[item].push(1)
              this.mergeLine[item] = i
            }
          }
        })
      })
    },
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      const index = this.merge.indexOf(column.property)
      if (index > -1) {
        const _row = this.mergeIndex[this.merge[index]][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    }
  },
  watch: {
    merge() {
      this.getMergeArr(this.data, this.merge)
    },
    dataLength() {
      this.getMergeArr(this.data, this.merge)
    }
  }
}

</script>
<style lang="scss" scoped>
.el-table {
  color: #2F3030 !important;
    /deep/.caret-wrapper{
    position: absolute;
    top: -3px;
   }
}

.lb-table {
  margin-top: 20px;

  /deep/.el-table .el-table__body tr:hover {
    color: #2F3030 !important;
    background-color: #F5FAF9 !important;

    /* 你想要的颜色 */
    &>td.el-table__cell {
      background-color: #F5FAF9
    }
  }

  /deep/.el-table .el-table__row.hover-row td {

    background-color: #F5FAF9 !important;
    /* 自定义的背景颜色 */
  }

  /deep/.el-input__inner:hover {
    border-color: #00B498 !important;

    outline: none;
  }

  /deep/.el-pager li:hover {
    color: #00B498;
  }

  /deep/.el-pager li.active {
    color: #00B498;
    cursor: default;
  }

  /deep/.el-pagination .btn-next:hover {
    color: #00B498;
  }

  /deep/.el-pagination .btn-prev:hover {
    color: #00B498;
  }
}
</style>
